import {memo} from 'react'
import type {EntryPointProps} from 'react-relay'

import type {BuildId} from '../../../../types'
import type {BuildArtifactStorageInfoFeatureIdQuery} from '../../../common/BuildArtifactsTree/BuildArtifactStorageInfo/__generated__/BuildArtifactStorageInfoFeatureIdQuery.graphql'
import BuildArtifactsTree from '../../../common/BuildArtifactsTree/BuildArtifactsTree'

type Props = {
  buildId: BuildId
}

type Queries = {
  storageFeatureIdQuery: BuildArtifactStorageInfoFeatureIdQuery
}

function BuildArtifactsTab({queries, props}: EntryPointProps<Queries, {}, Props, {}>) {
  return (
    <BuildArtifactsTree
      urlSync
      showToggleHidden
      showDownloadLink
      showStorageInfo
      storageFeatureIdQueryRef={queries.storageFeatureIdQuery}
      canSelectDirs
      buildId={props.buildId}
      compact={false}
    />
  )
}

export default memo(BuildArtifactsTab)
export type BuildArtifactsTabComponent = typeof BuildArtifactsTab
